import {Component} from '@angular/core';

@Component({
  selector: "side-menu-svg-sprite",
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol id="communityHomeIcon" viewBox="0 0 20 20" fill="none">
        <path
          opacity="0.2"
          d="M3 9.4722C3 9.02423 3 8.80025 3.05774 8.59398C3.10888 8.41126 3.19293 8.2394 3.30576 8.08685C3.43314 7.91464 3.60994 7.77713 3.96354 7.5021L9.25342 3.38776C9.52743 3.17463 9.66444 3.06807 9.81573 3.02711C9.94922 2.99096 10.0899 2.99096 10.2234 3.02711C10.3747 3.06807 10.5117 3.17463 10.7857 3.38776L16.0756 7.5021C16.4292 7.77713 16.606 7.91464 16.7334 8.08685C16.8462 8.2394 16.9303 8.41126 16.9814 8.59398C17.0391 8.80025 17.0391 9.02423 17.0391 9.4722V15.1151C17.0391 15.9887 17.0391 16.4255 16.8691 16.7592C16.7196 17.0527 16.4809 17.2914 16.1874 17.4409C15.8537 17.6109 15.4169 17.6109 14.5433 17.6109H5.49585C4.62222 17.6109 4.1854 17.6109 3.85172 17.4409C3.55821 17.2914 3.31957 17.0527 3.17002 16.7592C3 16.4255 3 15.9887 3 15.1151V9.4722Z"
          fill="#2D405D"
        />
        <path
          d="M6.99805 12.1513C7.34438 13.4969 8.56586 14.4911 10.0196 14.4911C11.4733 14.4911 12.6948 13.4969 13.0411 12.1513M9.25342 3.38776L3.96354 7.5021C3.60994 7.77713 3.43314 7.91464 3.30576 8.08686C3.19293 8.2394 3.10888 8.41126 3.05774 8.59398C3 8.80025 3 9.02423 3 9.4722V15.1151C3 15.9887 3 16.4255 3.17002 16.7592C3.31957 17.0527 3.55821 17.2914 3.85172 17.4409C4.1854 17.6109 4.62222 17.6109 5.49585 17.6109H14.5433C15.4169 17.6109 15.8537 17.6109 16.1874 17.4409C16.4809 17.2914 16.7196 17.0527 16.8691 16.7592C17.0391 16.4255 17.0391 15.9887 17.0391 15.1151V9.4722C17.0391 9.02423 17.0391 8.80025 16.9814 8.59398C16.9303 8.41126 16.8462 8.2394 16.7334 8.08686C16.606 7.91464 16.4292 7.77713 16.0756 7.5021L10.7857 3.38776C10.5117 3.17463 10.3747 3.06807 10.2234 3.02711C10.0899 2.99096 9.94922 2.99096 9.81573 3.02711C9.66444 3.06807 9.52743 3.17463 9.25342 3.38776Z"
          stroke="#2D405D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="communitySettingIcon" viewBox="0 0 20 20" fill="none">
        <g clip-path="url(#clip0_460_74)">
          <path
            opacity="0.2"
            d="M4.375 12.5C5.41053 12.5 6.25 11.6605 6.25 10.625C6.25 9.58947 5.41053 8.75 4.375 8.75C3.33947 8.75 2.5 9.58947 2.5 10.625C2.5 11.6605 3.33947 12.5 4.375 12.5Z"
            fill="#2D405D"
          />
          <path
            opacity="0.2"
            d="M10 8.75C11.0355 8.75 11.875 7.91053 11.875 6.875C11.875 5.83947 11.0355 5 10 5C8.96447 5 8.125 5.83947 8.125 6.875C8.125 7.91053 8.96447 8.75 10 8.75Z"
            fill="#2D405D"
          />
          <path
            opacity="0.2"
            d="M15.625 15C16.6605 15 17.5 14.1605 17.5 13.125C17.5 12.0895 16.6605 11.25 15.625 11.25C14.5895 11.25 13.75 12.0895 13.75 13.125C13.75 14.1605 14.5895 15 15.625 15Z"
            fill="#2D405D"
          />
          <path
            d="M4.375 12.5C5.41053 12.5 6.25 11.6605 6.25 10.625C6.25 9.58947 5.41053 8.75 4.375 8.75C3.33947 8.75 2.5 9.58947 2.5 10.625C2.5 11.6605 3.33947 12.5 4.375 12.5Z"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 8.75C11.0355 8.75 11.875 7.91053 11.875 6.875C11.875 5.83947 11.0355 5 10 5C8.96447 5 8.125 5.83947 8.125 6.875C8.125 7.91053 8.96447 8.75 10 8.75Z"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.625 15C16.6605 15 17.5 14.1605 17.5 13.125C17.5 12.0895 16.6605 11.25 15.625 11.25C14.5895 11.25 13.75 12.0895 13.75 13.125C13.75 14.1605 14.5895 15 15.625 15Z"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.375 3.125V8.75"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.625 3.125V11.25"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 3.125V5"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.375 12.5V16.875"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.625 15V16.875"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 8.75V16.875"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_460_74">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="communitySettingOneIcon" viewBox="0 0 20 20" fill="none">
        <g clip-path="url(#clip0_460_46)">
          <path
            opacity="0.2"
            d="M16.2392 9.62339L17.5501 7.98276C17.3733 7.31809 17.1087 6.67992 16.7634 6.08511L14.6774 5.85073C14.5108 5.66299 14.3331 5.48534 14.1454 5.3187L13.911 3.23198C13.3156 2.88872 12.6772 2.62601 12.0126 2.45073L10.372 3.76089C10.1212 3.74605 9.86967 3.74605 9.61885 3.76089L7.97822 2.44995C7.3157 2.62729 6.67967 2.89185 6.08682 3.23667L5.85244 5.32261C5.6647 5.48924 5.48704 5.6669 5.32041 5.85464L3.23369 6.08901C2.89043 6.68448 2.62772 7.32286 2.45244 7.98745L3.7626 9.62808C3.74775 9.8789 3.74775 10.1304 3.7626 10.3812L2.45166 12.0218C2.62848 12.6865 2.89305 13.3247 3.23838 13.9195L5.32432 14.1539C5.49095 14.3416 5.66861 14.5193 5.85635 14.6859L6.09072 16.7726C6.68619 17.1159 7.32457 17.3786 7.98916 17.5539L9.62979 16.2437C9.88061 16.2585 10.1321 16.2585 10.3829 16.2437L12.0235 17.5546C12.6882 17.3778 13.3264 17.1133 13.9212 16.7679L14.1556 14.682C14.3433 14.5153 14.521 14.3377 14.6876 14.15L16.7743 13.9156C17.1176 13.3201 17.3803 12.6817 17.5556 12.0171L16.2454 10.3765C16.2582 10.1256 16.2561 9.87409 16.2392 9.62339ZM10.0001 13.125C9.38203 13.125 8.77784 12.9417 8.26394 12.5983C7.75004 12.2549 7.3495 11.7669 7.11297 11.1958C6.87645 10.6248 6.81456 9.99648 6.93514 9.39029C7.05572 8.7841 7.35335 8.22728 7.79039 7.79024C8.22743 7.3532 8.78425 7.05558 9.39044 6.935C9.99663 6.81442 10.625 6.8763 11.196 7.11283C11.767 7.34935 12.2551 7.74989 12.5984 8.26379C12.9418 8.7777 13.1251 9.38188 13.1251 9.99995C13.1251 10.8288 12.7959 11.6236 12.2098 12.2097C11.6238 12.7957 10.8289 13.125 10.0001 13.125Z"
            fill="#2D405D"
          />
          <path
            d="M10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875C8.27411 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125Z"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.23691 13.9132C2.89158 13.3184 2.62701 12.6803 2.4502 12.0156L3.76113 10.375C3.74629 10.1241 3.74629 9.87265 3.76113 9.62183L2.45098 7.9812C2.62749 7.31642 2.89152 6.67802 3.23613 6.08276L5.32285 5.84839C5.48949 5.66065 5.66714 5.48299 5.85488 5.31636L6.08926 3.23042C6.68366 2.88745 7.32101 2.62499 7.98457 2.44995L9.6252 3.76089C9.87602 3.74605 10.1275 3.74605 10.3783 3.76089L12.0189 2.45073C12.6837 2.62725 13.3221 2.89127 13.9174 3.23589L14.1518 5.32261C14.3395 5.48924 14.5172 5.6669 14.6838 5.85464L16.7697 6.08901C17.1151 6.68383 17.3796 7.32199 17.5564 7.98667L16.2455 9.6273C16.2604 9.87812 16.2604 10.1296 16.2455 10.3804L17.5557 12.021C17.3804 12.6856 17.1177 13.324 16.7744 13.9195L14.6877 14.1539C14.5211 14.3416 14.3434 14.5193 14.1557 14.6859L13.9213 16.7718C13.3265 17.1172 12.6883 17.3817 12.0236 17.5585L10.383 16.2476C10.1322 16.2625 9.88071 16.2625 9.62988 16.2476L7.98926 17.5578C7.32467 17.3825 6.68628 17.1198 6.09082 16.7765L5.85645 14.6898C5.66871 14.5232 5.49105 14.3455 5.32441 14.1578L3.23691 13.9132Z"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_460_46">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="communityAnnounceIcon" viewBox="0 0 20 20" fill="none">
        <g clip-path="url(#clip0_460_31)">
          <path
            opacity="0.2"
            d="M8.125 12.5H5C4.1712 12.5 3.37634 12.1708 2.79029 11.5847C2.20424 10.9987 1.875 10.2038 1.875 9.375C1.875 8.5462 2.20424 7.75134 2.79029 7.16529C3.37634 6.57924 4.1712 6.25 5 6.25H8.125V12.5Z"
            fill="#2D405D"
          />
          <path
            d="M8.125 6.25V15.6773C8.12494 15.7801 8.09953 15.8813 8.05101 15.9719C8.0025 16.0626 7.93238 16.1398 7.84688 16.1969L6.9875 16.7695C6.90414 16.8251 6.80865 16.8598 6.70906 16.8708C6.60947 16.8817 6.50872 16.8686 6.41528 16.8324C6.32184 16.7963 6.23846 16.7382 6.17217 16.6631C6.10588 16.5879 6.05862 16.498 6.03438 16.4008L5 12.5"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.5 15.625C17.5 15.7441 17.466 15.8606 17.402 15.961C17.338 16.0613 17.2466 16.1413 17.1387 16.1915C17.0308 16.2418 16.9108 16.2601 16.7928 16.2445C16.6748 16.2288 16.5637 16.1798 16.4727 16.1032C12.3789 12.6688 8.125 12.5 8.125 12.5H5C4.1712 12.5 3.37634 12.1708 2.79029 11.5848C2.20424 10.9987 1.875 10.2039 1.875 9.37505C1.875 8.54625 2.20424 7.75139 2.79029 7.16534C3.37634 6.57929 4.1712 6.25005 5 6.25005H8.125C8.125 6.25005 12.3789 6.0813 16.4727 2.64771C16.5637 2.57112 16.6747 2.52211 16.7926 2.50643C16.9105 2.49075 17.0305 2.50905 17.1384 2.55917C17.2462 2.6093 17.3376 2.68917 17.4016 2.78941C17.4657 2.88965 17.4998 3.00609 17.5 3.12505V15.625Z"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_460_31">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="matrix(-1 0 0 1 20 0)"
            />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="communityIntroIcon" viewBox="0 0 20 20" fill="none">
        <g clip-path="url(#clip0_460_37)">
          <path
            opacity="0.2"
            d="M16.25 5.625H3.75V14.375H16.25V5.625Z"
            fill="#2D405D"
          />
          <path
            d="M3.75 14.375V5.625"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.25 5.625V14.375"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.875 3.125H3.125C2.77982 3.125 2.5 3.40482 2.5 3.75V5C2.5 5.34518 2.77982 5.625 3.125 5.625H16.875C17.2202 5.625 17.5 5.34518 17.5 5V3.75C17.5 3.40482 17.2202 3.125 16.875 3.125Z"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 14.375V16.875"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 19.375C10.6904 19.375 11.25 18.8154 11.25 18.125C11.25 17.4346 10.6904 16.875 10 16.875C9.30964 16.875 8.75 17.4346 8.75 18.125C8.75 18.8154 9.30964 19.375 10 19.375Z"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2.5 14.375H17.5"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_460_37">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="communityRoomIcon" viewBox="0 0 20 20" fill="none">
        <g clip-path="url(#clip0_460_52)">
          <path
            opacity="0.2"
            d="M10.3125 16.875H3.72422C3.6455 16.8751 3.56753 16.8597 3.49479 16.8296C3.42204 16.7995 3.35594 16.7554 3.30028 16.6997C3.24462 16.6441 3.20048 16.578 3.1704 16.5052C3.14033 16.4325 3.1249 16.3545 3.125 16.2758V9.6875C3.125 7.78126 3.88225 5.95309 5.23017 4.60517C6.57809 3.25725 8.40626 2.5 10.3125 2.5C11.2564 2.5 12.191 2.68591 13.063 3.04712C13.9351 3.40832 14.7274 3.93775 15.3948 4.60517C16.0623 5.27259 16.5917 6.06493 16.9529 6.93696C17.3141 7.80899 17.5 8.74362 17.5 9.6875C17.5 10.6314 17.3141 11.566 16.9529 12.438C16.5917 13.3101 16.0623 14.1024 15.3948 14.7698C14.7274 15.4373 13.9351 15.9667 13.063 16.3279C12.191 16.6891 11.2564 16.875 10.3125 16.875Z"
            fill="#2D405D"
          />
          <path
            d="M10.3125 16.875H3.72422C3.6455 16.8751 3.56753 16.8597 3.49479 16.8296C3.42204 16.7995 3.35594 16.7554 3.30028 16.6997C3.24462 16.6441 3.20048 16.578 3.1704 16.5052C3.14033 16.4325 3.1249 16.3545 3.125 16.2758V9.6875C3.125 7.78126 3.88225 5.95309 5.23017 4.60517C6.57809 3.25725 8.40626 2.5 10.3125 2.5C11.2564 2.5 12.191 2.68591 13.063 3.04712C13.9351 3.40832 14.7274 3.93775 15.3948 4.60517C16.0623 5.27259 16.5917 6.06493 16.9529 6.93696C17.3141 7.80899 17.5 8.74362 17.5 9.6875C17.5 10.6314 17.3141 11.566 16.9529 12.438C16.5917 13.3101 16.0623 14.1024 15.3948 14.7698C14.7274 15.4373 13.9351 15.9667 13.063 16.3279C12.191 16.6891 11.2564 16.875 10.3125 16.875Z"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_460_52">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="communityAllRoomsIcon" viewBox="0 0 20 20" fill="none">
        <g clip-path="url(#clip0_460_56)">
          <path
            opacity="0.2"
            d="M6.25 8.75C7.63071 8.75 8.75 7.63071 8.75 6.25C8.75 4.86929 7.63071 3.75 6.25 3.75C4.86929 3.75 3.75 4.86929 3.75 6.25C3.75 7.63071 4.86929 8.75 6.25 8.75Z"
            fill="#2D405D"
          />
          <path
            opacity="0.2"
            d="M13.75 8.75C15.1307 8.75 16.25 7.63071 16.25 6.25C16.25 4.86929 15.1307 3.75 13.75 3.75C12.3693 3.75 11.25 4.86929 11.25 6.25C11.25 7.63071 12.3693 8.75 13.75 8.75Z"
            fill="#2D405D"
          />
          <path
            opacity="0.2"
            d="M6.25 16.25C7.63071 16.25 8.75 15.1307 8.75 13.75C8.75 12.3693 7.63071 11.25 6.25 11.25C4.86929 11.25 3.75 12.3693 3.75 13.75C3.75 15.1307 4.86929 16.25 6.25 16.25Z"
            fill="#2D405D"
          />
          <path
            opacity="0.2"
            d="M13.75 16.25C15.1307 16.25 16.25 15.1307 16.25 13.75C16.25 12.3693 15.1307 11.25 13.75 11.25C12.3693 11.25 11.25 12.3693 11.25 13.75C11.25 15.1307 12.3693 16.25 13.75 16.25Z"
            fill="#2D405D"
          />
          <path
            d="M6.25 8.75C7.63071 8.75 8.75 7.63071 8.75 6.25C8.75 4.86929 7.63071 3.75 6.25 3.75C4.86929 3.75 3.75 4.86929 3.75 6.25C3.75 7.63071 4.86929 8.75 6.25 8.75Z"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.75 8.75C15.1307 8.75 16.25 7.63071 16.25 6.25C16.25 4.86929 15.1307 3.75 13.75 3.75C12.3693 3.75 11.25 4.86929 11.25 6.25C11.25 7.63071 12.3693 8.75 13.75 8.75Z"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.25 16.25C7.63071 16.25 8.75 15.1307 8.75 13.75C8.75 12.3693 7.63071 11.25 6.25 11.25C4.86929 11.25 3.75 12.3693 3.75 13.75C3.75 15.1307 4.86929 16.25 6.25 16.25Z"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.75 16.25C15.1307 16.25 16.25 15.1307 16.25 13.75C16.25 12.3693 15.1307 11.25 13.75 11.25C12.3693 11.25 11.25 12.3693 11.25 13.75C11.25 15.1307 12.3693 16.25 13.75 16.25Z"
            stroke="#2D405D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_460_56">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="communityMyProfileIcon" viewBox="0 0 17 22" fill="none">
        <path d="M6.33333 3.66675H2.33333C1.97971 3.66675 1.64057 3.80722 1.39052 4.05727C1.14048 4.30732 1 4.64646 1 5.00008V19.6667C1 20.0204 1.14048 20.3595 1.39052 20.6096C1.64057 20.8596 1.97971 21.0001 2.33333 21.0001H14.3333C14.687 21.0001 15.0261 20.8596 15.2761 20.6096C15.5262 20.3595 15.6667 20.0204 15.6667 19.6667V5.00008C15.6667 4.64646 15.5262 4.30732 15.2761 4.05727C15.0261 3.80722 14.687 3.66675 14.3333 3.66675H10.3333" stroke="#2D405D" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.3335 3C10.3335 2.46957 10.1228 1.96086 9.74771 1.58579C9.37264 1.21071 8.86393 1 8.3335 1C7.80306 1 7.29436 1.21071 6.91928 1.58579C6.54421 1.96086 6.3335 2.46957 6.3335 3V5.66667C6.3335 5.84348 6.40373 6.01305 6.52876 6.13807C6.65378 6.2631 6.82335 6.33333 7.00016 6.33333H9.66683C9.84364 6.33333 10.0132 6.2631 10.1382 6.13807C10.2633 6.01305 10.3335 5.84348 10.3335 5.66667V3Z" fill="#E1DEF0" stroke="#2D405D" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.3335 12C5.3335 12.7956 5.64957 13.5587 6.21218 14.1213C6.77479 14.6839 7.53785 15 8.3335 15C9.12915 15 9.89221 14.6839 10.4548 14.1213C11.0174 13.5587 11.3335 12.7956 11.3335 12C11.3335 11.2044 11.0174 10.4413 10.4548 9.87868C9.89221 9.31607 9.12915 9 8.3335 9C7.53785 9 6.77479 9.31607 6.21218 9.87868C5.64957 10.4413 5.3335 11.2044 5.3335 12Z" fill="#E1DEF0" stroke="#2D405D" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.6667 20.9999C13.493 19.7085 12.8567 18.524 11.8759 17.6662C10.8951 16.8085 9.63633 16.3357 8.33333 16.3357C7.03034 16.3357 5.7716 16.8085 4.79077 17.6662C3.80994 18.524 3.17365 19.7085 3 20.9999" fill="#E1DEF0"/>
        <path d="M13.6667 20.9999C13.493 19.7085 12.8567 18.524 11.8759 17.6662C10.8951 16.8085 9.63633 16.3357 8.33333 16.3357C7.03034 16.3357 5.7716 16.8085 4.79077 17.6662C3.80994 18.524 3.17365 19.7085 3 20.9999" stroke="#2D405D" stroke-linecap="round" stroke-linejoin="round"/>
      </symbol>

    </svg>
  `,
})
export class SideMenuSvgSpriteComponent {}
